export const deviceConstants = {
    disclaimerText:
        'You are about to update the config settings for {deviceCount} device(s). Sending an invalid configuration to a device can potentially stop that device from reporting correct scores, or could stop the device from working altogether. Please ensure you have provided correct parameters for the devices and have stayed within the ranges as prescribed to you by Intercept IP before you continue. Configuration will be replaced with the number of devices in the selected group.',
    errorMessages: {
        invalidJson: 'Invalid configuration, please enter a valid JSON configuration.',
        versionMissing: 'Version is missing from JSON configuration, please include version with the key "DeviceConfigurationVersion"',
        unknownError: 'Unable to update device configuration, please try again later.'
    }
};
